export const accountListData = {
  Data: [
    {
      Id: '710f92b2-cedc-4a85-8c7a-a535115eae22',
      Identity: {
        FirstName: 'Valery',
        LastName: 'Sernet',
        Email: 'vsernet@lw.com',
        BirthDate: '2001-12-08T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['IT'],
        BirthCountry: 'FR',
        BirthPlace: 'Paris',
        Phone: '+33 6 12 34 56 78',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: null,
      Profiles: [
        {
          Id: 'a1413f53-5162-4df5-a9ea-33bc2d723134',
          PartnerId: '8cc9dbc4-4b9a-4dd7-a377-11a751b314a5',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'AWAITING_INFORMATION',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '376323476',
              LegacyInternalId: null,
              Balance: 0,
              SituationId: 6,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      AccountBalance: 0,
      CreatedAt: '2025-04-25T14:20:11.588Z',
      UpdatedAt: '2025-04-25T14:20:11.588Z',
      Type: 'INDIVIDUAL',
      Requirements: [],
      Restrictions: null,
      Documents: []
    },
    {
      Id: 'cdc3b4eb-bf1b-4f56-bb0d-5e90d7a047ca',
      Identity: {
        FirstName: null,
        LastName: null,
        Email: null,
        BirthDate: null,
        ResidenceCountry: null,
        Name: 'Satterfield - Sporer',
        Type: 'COMPANY',
        RegistrationCountry: 'FR',
        RegistrationDate: '1992-03-21T00:00:00Z',
        Nationalities: [],
        BirthCountry: null,
        BirthPlace: null,
        Phone: null,
        IdentificationNumber: 'XXX 457 897',
        Description:
          'Customer temporary legal company Conseil pour les affaires et autres conseils de gestion',
        People: [
          { FirstName: 'Tony', LastName: 'Stark', Role: 'LEGAL_REPRESENTATIVE' },
          { FirstName: 'Peter', LastName: 'Parker', Role: 'UBO' },
          { FirstName: 'Mary', LastName: 'Jane', Role: 'UBO' }
        ]
      },
      Status: 'CREATED',
      OnboardingId: '25e6a1eb-55fc-4c7b-ac5c-3a276c58f194',
      Profiles: [
        {
          Id: '9c3ca9ec-6a8b-45ea-848e-979e4fba9fd7',
          PartnerId: '5ce89522-c41c-4739-bac0-8dd8627668e6',
          SolutionId: '721b8875-451c-4a47-b768-83af1889536e',
          SolutionName: 'TEST001NEWARCHI',
          ActivityType: 'CROWDLENDING',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: undefined
          },
          Wallets: [
            {
              ExternalWalletId: '7c453612-d4e8-40b6-b236-1375a76cdfa8',
              LegacyInternalId: 558017,
              Balance: 470235,
              SituationId: 6,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        },
        {
          Id: '3e15c97e-28a5-4d57-b29c-9fd1c601d885',
          PartnerId: 'd9bc5ba3-2a2e-4e98-86f6-7dd83c57bc97',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'REJECTED',
            SubStatus: 'REGULATORY_REASON'
          },
          Wallets: [
            {
              ExternalWalletId: '12433523',
              LegacyInternalId: 558016,
              Balance: 10000,
              SituationId: 6,
              Blocking: ['RESTRICTED'],
              Type: 'TECHNICAL'
            }
          ]
        }
      ],
      AccountBalance: 480235,
      CreatedAt: '2025-04-28T11:20:22.889Z',
      UpdatedAt: '0001-01-01T00:00:00',
      Type: 'LEGAL_ENTITY',
      Requirements: [
        {
          Id: '6ca90af5-4892-4cfb-b5fe-56b95a85e987',
          Type: 'KYC_UPDATE',
          DueDate: '2026-05-01T18:01:33.908Z',
          Status: 'REQUESTED'
        }
      ],
      Restrictions: [],
      Documents: [
        {
          Id: '680f65824fcc59ebbb5cb4e0',
          AccountId: null,
          DocumentType: null,
          CreatedAt: '2025-04-28T11:24:50.445Z',
          Status: 'PENDING_VERIFICATION',
          Type: 'KNOWN_FACES_REPORT',
          SubStatus: 'WAITING_FOR_OCR_VERIFICATION',
          FileId: '60487c8c-8fac-4fec-b9df-b3c05c0af80e',
          FileName: '60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          FileExtension: 'pdf',
          SLA: 2,
          Deadline: '2025-04-28T13:24:50.444Z',
          Partner: 'TEST001NEWARCHI',
          UpdatedAt: '2025-04-28T11:24:50.445Z',
          DownloadUrl:
            'https://ws.dev.lemonway.com:4431/backend-core/api/test001newarchi/accounts/b939096b-c764-454f-b1db-0b9cc58d941a/documents/60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          Comment: null,
          LegalEntityId: '3f1369fb-2e39-4a68-871b-cbd94a41c6cd'
        },
        {
          Id: '680f65824fcc59ebbb5cb4e1',
          AccountId: null,
          DocumentType: null,
          CreatedAt: '2025-04-28T11:24:50.445Z',
          Status: 'PENDING_VERIFICATION',
          Type: '123',
          SubStatus: 'WAITING_FOR_OCR_VERIFICATION',
          FileId: '60487c8c-8fac-4fec-b9df-b3c05c0af80e',
          FileName: '60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          FileExtension: 'pdf',
          SLA: 2,
          Deadline: '2025-04-28T13:24:50.444Z',
          Partner: 'TEST001NEWARCHI',
          UpdatedAt: '2025-04-28T11:24:50.445Z',
          DownloadUrl:
            'https://ws.dev.lemonway.com:4431/backend-core/api/test001newarchi/accounts/b939096b-c764-454f-b1db-0b9cc58d941a/documents/60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          Comment: null,
          LegalEntityId: '3f1369fb-2e39-4a68-871b-cbd94a41c6cd'
        },
        {
          Id: '680f65824fcc59ebbb5cb4e2',
          AccountId: null,
          DocumentType: null,
          CreatedAt: '2025-04-28T11:24:50.445Z',
          Status: 'PENDING_VERIFICATION',
          Type: null,
          SubStatus: 'WAITING_FOR_OCR_VERIFICATION',
          FileId: '60487c8c-8fac-4fec-b9df-b3c05c0af80e',
          FileName: '60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          FileExtension: 'pdf',
          SLA: 2,
          Deadline: '2025-04-28T13:24:50.444Z',
          Partner: 'TEST001NEWARCHI',
          UpdatedAt: '2025-04-28T11:24:50.445Z',
          DownloadUrl:
            'https://ws.dev.lemonway.com:4431/backend-core/api/test001newarchi/accounts/b939096b-c764-454f-b1db-0b9cc58d941a/documents/60487c8c-8fac-4fec-b9df-b3c05c0af80e.pdf',
          Comment: null,
          LegalEntityId: '3f1369fb-2e39-4a68-871b-cbd94a41c6cd'
        }
      ]
    },
    {
      Id: '0c735d33-4113-4839-a310-ebd28d2241f6',
      Identity: {
        FirstName: null,
        LastName: null,
        Email: null,
        BirthDate: null,
        ResidenceCountry: null,
        Name: 'Schumm Group CORP',
        Type: 'COMPANY',
        RegistrationCountry: 'ES',
        RegistrationDate: '2024-05-17T00:00:00Z'
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '4ee377b3-6840-4bb2-85ba-faea1c436a54',
          PartnerId: '80c2c2dc-3718-4dde-84f3-207ebd193637',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: 'a0f8d7aa-7d3e-47ad-85b2-45619f98104f',
              LegacyInternalId: 558021,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT',
              Project: {
                ProjectType: 'FAREWELL',
                WeddingRelation: null,
                Beneficiary: {
                  FirstName: 'Jude',
                  LastName: 'Cassin',
                  BirthDate: '1951-01-09T00:00:00Z'
                },
                Description: null,
                Website: null
              }
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:21:47.104Z',
      UpdatedAt: '2025-04-25T14:25:11.607Z',
      Type: 'LEGAL_ENTITY',
      Requirements: [
        {
          Id: '91f2f7ae-4df7-44fd-bcc6-ecf374db4eb7',
          Type: 'KYC_UPDATE',
          DueDate: '2026-04-01T09:44:22.104Z',
          Status: 'REQUESTED'
        }
      ],
      Restrictions: [],
      Documents: []
    },
    {
      Id: '59e68f88-ee94-40af-a843-ec909ed2d4f9',
      Identity: {
        FirstName: 'Bernard',
        LastName: 'François',
        Email: 'bfrancois@lw.com',
        BirthDate: '1954-02-08T00:00:00.000Z',
        ResidenceCountry: 'BE',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['BE', 'NL'],
        BirthCountry: 'BE',
        BirthPlace: 'Brussels',
        Phone: '+32 2 123 45 67',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '5902f790-9385-4193-aaf3-8f126da71989',
          PartnerId: 'e7bbc566-4053-417e-aded-5e5571f1d23d',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'AWAITING_INFORMATION',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '7623457612',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:21:26.257Z',
      UpdatedAt: '2025-04-25T14:21:26.257Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: 'eced0fc9-1a4d-4cf8-a184-f5eba29f3e76',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-01T14:19:09.013Z',
          Status: 'REQUESTED'
        }
      ],
      Restrictions: [
        {
          Id: 'e3509f6a-b3c0-456f-87f5-af11df82a318',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-15T10:11:58.410Z',
          RequirementIds: ['eced0fc9-1a4d-4cf8-a184-f5eba29f3e76']
        }
      ],
      Documents: []
    },

    {
      Id: 'a7f5107d-58f3-457d-ada3-cfb2c29cfa41',
      Identity: {
        FirstName: 'Baptiste',
        LastName: 'Sernet',
        Email: 'bsernet@lw.com',
        BirthDate: '1992-10-12T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['FR'],
        BirthCountry: 'FR',
        BirthPlace: 'Lyon',
        Phone: '+33 6 98 76 54 32',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '208f12fe-dd96-4ec8-b9dc-ae8cefa13f7c',
          PartnerId: 'b9566a5a-9c53-4ea8-b7c3-d30c8f274508',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'DONOR',
          RelationshipType: 'USER',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '245213423',
              LegacyInternalId: 558020,
              Balance: 0,
              Type: 'TECHNICAL',
              Project: {
                ProjectType: 'WEDDING',
                WeddingRelation: 'BRIDE_GROOM',
                Beneficiary: {
                  FirstName: 'John',
                  LastName: 'Cooper',
                  BirthDate: '1987-07-04T00:00:00Z'
                },
                Description: null,
                Website: null
              }
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:19:30.126Z',
      UpdatedAt: '2025-04-25T14:19:31.535Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '8f2f0e1f-7ffc-4ec5-a89b-cb4c46ee39c3',
          Type: 'KYC_UPDATE',
          DueDate: '2026-05-11T17:23:10.444Z',
          Status: 'UNDER_ANALYSIS'
        }
      ],
      Restrictions: [],
      Documents: []
    },
    {
      Id: '80ec58de-9236-47d4-8b44-bb5b0081c781',
      Identity: {
        FirstName: 'Basile',
        LastName: 'Gugge',
        Email: 'bgugge@lw.com',
        BirthDate: '1994-02-02T00:00:00.000Z',
        ResidenceCountry: 'AD',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['FR'],
        BirthCountry: 'FR',
        BirthPlace: 'Bordeaux',
        Phone: '+33 6 11 22 33 44',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: 'b15acf3c-3fb5-4c32-89e6-7fee8228773c',
          PartnerId: '89228912-5ee5-4f61-b298-bbdb7ff7ded8',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'DONOR',
          RelationshipType: 'USER',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '376234734',
              LegacyInternalId: 558019,
              Balance: 0,
              Type: 'TECHNICAL',
              Project: {
                ProjectType: 'BIRTHDAY',
                WeddingRelation: null,
                Beneficiary: {
                  FirstName: 'Mara',
                  LastName: 'Lind',
                  BirthDate: '1995-02-18T00:00:00Z'
                },
                Description: null,
                Website: null
              }
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:18:18.726Z',
      UpdatedAt: '2025-04-25T14:18:19.755Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: 'fe0e7679-b607-43b1-9e91-f0cf2e5a8a39',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-31T07:45:54.321Z',
          Status: 'UNDER_ANALYSIS'
        }
      ],
      Restrictions: [],
      Documents: []
    },
    {
      Id: '3778fe7b-4af9-4b6a-80d3-c586bd69d4df',
      Identity: {
        FirstName: 'Cecil',
        LastName: 'Runte',
        Email: 'Vaughn.Torphy42@hotmail.com',
        BirthDate: '1956-06-01T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['DE'],
        BirthCountry: 'DE',
        BirthPlace: 'Berlin',
        Phone: '+49 30 123 456 78',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: 'f09dad8b-da13-4e59-8e2e-ee95072febcf',
      Profiles: [
        {
          Id: 'c4214b84-971f-4e83-8170-bd8b2ee75218',
          PartnerId: 'f400c372-ecef-47c1-a1bd-1985b4704b4a',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'INFORMATION_COLLECTION_IN_PROGRESS',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '9dd0e47b-a82d-4688-9ebc-1e4afd23f150',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:17:23.12Z',
      UpdatedAt: '2025-04-25T14:17:25.971Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9fe',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-23T20:59:03.114Z',
          Status: 'UNDER_ANALYSIS'
        }
      ],
      Restrictions: [
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae344',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-24T09:11:32.773Z',
          RequirementIds: ['4e2bf5d7-4098-4112-9e3f-ac85a477f9fe']
        }
      ],
      Documents: []
    },
    {
      Id: '5c7b43b8-2b15-4dc7-adf1-919efcd7ded9',
      Identity: {
        FirstName: 'Sarah',
        LastName: 'Merill',
        Email: 'smerill@lw.com',
        BirthDate: '2001-12-31T00:00:00.000Z',
        ResidenceCountry: 'AD',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['ES'],
        BirthCountry: 'ES',
        BirthPlace: 'Madrid',
        Phone: '+34 91 123 45 67',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '0ef88541-c037-4533-a559-1ed13788ab6b',
          PartnerId: '156f96e5-f4e1-469a-a284-06e6055ad8a0',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'DONOR',
          RelationshipType: 'USER',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '7623563246',
              LegacyInternalId: 558018,
              Balance: 0,
              Type: 'TECHNICAL',
              Project: {
                ProjectType: 'CHARITY',
                WeddingRelation: null,
                Beneficiary: null,
                Description: 'Fundraiser for the local animal shelter',
                Website: 'https://example.org/shelter'
              }
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:15:08.901Z',
      UpdatedAt: '2025-04-25T14:15:09.741Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '6aaae9f2-5979-4f54-9324-d5cb42b0c31f',
          Type: 'KYC_UPDATE',
          DueDate: '2026-05-02T13:13:13.130Z',
          Status: 'REJECTED'
        }
      ],
      Restrictions: [],
      Documents: []
    },
    {
      Id: '3bb78990-85a8-42bd-9707-5dcca0626c78',
      Identity: {
        FirstName: 'Mallie',
        LastName: 'Windler',
        Email: 'Myrtie23@gmail.com',
        BirthDate: '1956-06-01T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['IT'],
        BirthCountry: 'IT',
        BirthPlace: 'Rome',
        Phone: '+39 06 123 456 78',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: '6d9f8c9d-f303-4770-bb43-e54c65c175d0',
      Profiles: [
        {
          Id: 'a68fc30a-7d21-4600-acc2-a504885dd315',
          PartnerId: 'ca73dfbb-7af2-4002-a3f7-77b383e60678',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'INFORMATION_COLLECTION_IN_PROGRESS',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '97e52af4-2bf1-4430-ac09-370b8c096db6',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:15:07.104Z',
      UpdatedAt: '2025-04-25T14:15:09.674Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '6aaae9f2-5979-4f54-9324-d5cb42b0c31f',
          Type: 'KYC_UPDATE',
          DueDate: '2026-04-02T13:13:13.130Z',
          Status: 'REJECTED'
        }
      ],
      Restrictions: [],
      Documents: []
    },
    {
      Id: '5d71079d-f4eb-4f93-9ba4-3e23a6164cab',
      Identity: {
        FirstName: 'Debbie',
        LastName: 'Visham',
        Email: 'dvisham@lw.com',
        BirthDate: '2000-01-03T00:00:00.000Z',
        ResidenceCountry: 'AO',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['FR'],
        BirthCountry: 'FR',
        BirthPlace: 'Marseille',
        Phone: '+33 6 55 44 33 22',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '3e15c97e-28a5-4d57-b29c-9fd1c601d885',
          PartnerId: 'd9bc5ba3-2a2e-4e98-86f6-7dd83c57bc97',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'DONOR',
          RelationshipType: 'USER',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '12433523',
              LegacyInternalId: 558016,
              Balance: 0,
              Type: 'TECHNICAL'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:03:14.535Z',
      UpdatedAt: '2025-04-25T14:03:29.173Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: 'd5904a8a-d9fa-473a-a7bf-d46f02f88cd0',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-20T03:18:45.600Z',
          Status: 'REJECTED'
        }
      ],
      Restrictions: [
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae344',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-24T09:11:32.773Z',
          RequirementIds: ['d5904a8a-d9fa-473a-a7bf-d46f02f88cd0']
        }
      ],
      Documents: []
    },
    {
      Id: '5d71079d-f4eb-4f93-9ba4-3e23a6164gzr',
      Identity: {
        FirstName: 'Sammy',
        LastName: 'Brown',
        Email: 'sbrown@lw.com',
        BirthDate: '2000-01-03T00:00:00.000Z',
        ResidenceCountry: 'AO',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['GB'],
        BirthCountry: 'GB',
        BirthPlace: 'London',
        Phone: '+44 20 1234 5678',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'ACCEPTED',
      OnboardingId: null,
      Profiles: [
        {
          Id: '3e15c97e-28a5-4d57-b29c-9fd1c601d885',
          PartnerId: 'd9bc5ba3-2a2e-4e98-86f6-7dd83c57bc97',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'DONOR',
          RelationshipType: 'USER',
          Status: {
            Type: 'ACCEPTED',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '12433523',
              LegacyInternalId: 558016,
              Balance: 0,
              Type: 'TECHNICAL'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:03:14.535Z',
      UpdatedAt: '2025-04-25T14:03:29.173Z',
      Type: 'INDIVIDUAL',
      Requirements: [],
      Restrictions: [
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae344',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-24T09:11:32.773Z',
          RequirementIds: []
        }
      ],
      Documents: []
    },
    {
      Id: '3778fe7b-4af9-4b6a-80d3-c586bd69d4en',
      Identity: {
        FirstName: 'François',
        LastName: 'Bernard',
        Email: 'fbernard@hotmail.com',
        BirthDate: '1956-06-01T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['FR'],
        BirthCountry: 'FR',
        BirthPlace: 'Toulouse',
        Phone: '+33 5 61 12 34 56',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: 'f09dad8b-da13-4e59-8e2e-ee95072febcf',
      Profiles: [
        {
          Id: 'c4214b84-971f-4e83-8170-bd8b2ee75218',
          PartnerId: 'f400c372-ecef-47c1-a1bd-1985b4704b4a',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'INFORMATION_COLLECTION_IN_PROGRESS',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '9dd0e47b-a82d-4688-9ebc-1e4afd23f150',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:17:23.12Z',
      UpdatedAt: '2025-04-25T14:17:25.971Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9fe',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-23T20:59:03.114Z',
          Status: 'REQUESTED'
        }
      ],
      Restrictions: [
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae344',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-24T09:11:32.773Z',
          RequirementIds: ['4e2bf5d7-4098-4112-9e3f-ac85a477f9fe']
        },
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae723',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-28T09:11:32.773Z',
          RequirementIds: ['4e2bf5d7-4098-4112-9e3f-ac85a477f9fe']
        }
      ],
      Documents: []
    },
    {
      Id: '3778fe7b-4af9-4b6a-80d3-c586bd69d4az',
      Identity: {
        FirstName: 'Ophelia',
        LastName: 'Smith',
        Email: 'osmith@hotmail.com',
        BirthDate: '1999-06-01T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['IT'],
        BirthCountry: 'IT',
        BirthPlace: 'Milan',
        Phone: '+39 02 123 456 78',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: 'f09dad8b-da13-4e59-8e2e-ee95072febcf',
      Profiles: [
        {
          Id: 'c4214b84-971f-4e83-8170-bd8b2ee75218',
          PartnerId: 'f400c372-ecef-47c1-a1bd-1985b4704b4a',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'INFORMATION_COLLECTION_IN_PROGRESS',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '9dd0e47b-a82d-4688-9ebc-1e4afd23f150',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:17:23.12Z',
      UpdatedAt: '2025-04-25T14:17:25.971Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9fe',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-23T20:59:03.114Z',
          Status: 'REQUESTED'
        },
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9gr',
          Type: 'KYC_UPDATE',
          DueDate: '2026-05-23T20:59:03.114Z',
          Status: 'REJECTED'
        }
      ],
      Restrictions: [
        {
          Id: '8376b77d-d89d-4dc6-8a1f-bfcb698ae344',
          Category: 'KYC',
          Reason: 'KYC_OUTDATED',
          ActivatedAt: '2026-03-24T09:11:32.773Z',
          RequirementIds: ['4e2bf5d7-4098-4112-9e3f-ac85a477f9fe']
        }
      ],
      Documents: []
    },
    {
      Id: '3778fe7b-4af9-4b6a-80d3-c586bd69d4cv',
      Identity: {
        FirstName: 'Rosa',
        LastName: 'Conner',
        Email: 'rconner@hotmail.com',
        BirthDate: '1984-06-01T00:00:00.000Z',
        ResidenceCountry: 'FR',
        Name: null,
        Type: null,
        RegistrationCountry: null,
        RegistrationDate: '0001-01-01T00:00:00',
        Nationalities: ['ES'],
        BirthCountry: 'ES',
        BirthPlace: 'Barcelona',
        Phone: '+34 93 123 45 67',
        IdentificationNumber: null,
        Description: null,
        People: []
      },
      Status: 'CREATED',
      OnboardingId: 'f09dad8b-da13-4e59-8e2e-ee95072febcf',
      Profiles: [
        {
          Id: 'c4214b84-971f-4e83-8170-bd8b2ee75218',
          PartnerId: 'f400c372-ecef-47c1-a1bd-1985b4704b4a',
          SolutionId: 'bb06f579-45e7-4ad5-a1c1-0da5da8aa9fb',
          SolutionName: 'TEST001ATOSV2',
          ActivityType: 'CROWDFUNDING_DONATION',
          Type: 'PROJECT_HOLDER',
          RelationshipType: 'BUSINESS_RELATIONSHIP',
          Status: {
            Type: 'INFORMATION_COLLECTION_IN_PROGRESS',
            SubStatus: null
          },
          Wallets: [
            {
              ExternalWalletId: '9dd0e47b-a82d-4688-9ebc-1e4afd23f150',
              LegacyInternalId: null,
              Balance: 0,
              Type: 'PAYMENT_ACCOUNT'
            }
          ]
        }
      ],
      CreatedAt: '2025-04-25T14:17:23.12Z',
      UpdatedAt: '2025-04-25T14:17:25.971Z',
      Type: 'INDIVIDUAL',
      Requirements: [
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9fe',
          Type: 'KYC_UPDATE',
          DueDate: '2026-03-23T20:59:03.114Z',
          Status: 'REQUESTED'
        },
        {
          Id: '4e2bf5d7-4098-4112-9e3f-ac85a477f9gr',
          Type: 'KYC_UPDATE',
          DueDate: '2026-05-23T20:59:03.114Z',
          Status: 'UNDER_ANALYSIS'
        }
      ],
      Restrictions: [],
      Documents: []
    }
  ],
  NextLink: '',
  PrevLink: ''
};
